import { FC } from 'react';
import { IFixedTermItem } from '../../types/IFixedTermItem';
import { Box, HStack, Span } from '@bpba/ui-components';
import { MarginProps } from 'styled-system';
import styled from 'styled-components';
import { renderDate } from '../RenderDate';
import { CBU_CHECK_MSG } from '../../constants/data';
import { StyledBox } from '../../components/shared/StyledBox';
import { renderAmount } from '../RenderAmount';
import { renderRate } from '../RenderRate';

export type FixedTermDetailData = IFixedTermItem & {
  cbu?: string;
  alias?: string;
};

type Props = {
  data: FixedTermDetailData;
} & MarginProps;

export const FixedTermDetail: FC<Props> = ({ data, ...otherProps }) => {
  if (data == null) return <></>;

  return (
    <HStack color={'primary.0'} mb={'48px'} mt={'32px'} fontSize={['14px', '18px']} lineHeight={['20px', '24px']} {...otherProps}>
      <StyledBox flexDirection={'column'} gap={'35px'}>
        <BlockBox display={['block !important', null, null, 'none !important']}>
          Alias/CBU
          <StyledB>
            {data.cbu}
            {data.alias}
          </StyledB>
        </BlockBox>
        <BlockBox>
          Invertís <StyledB>{renderAmount(data.amount)}</StyledB>
        </BlockBox>
        <BlockBox>
          Ganás
          <StyledB>{renderAmount(data.interest)}</StyledB>
        </BlockBox>
        <BlockBox>
          Retirás
          <StyledB>{renderAmount(data.finalAmount)}</StyledB>{' '}
        </BlockBox>
        <BlockBox>
          TNA
          <StyledB>{renderRate(data.tna)}</StyledB>
        </BlockBox>
        <BlockBox>
          Período
          <StyledB>{renderDate(data.createdDate)}</StyledB>-<StyledB>{renderDate(data.expiredDate)}</StyledB>
          <StyledB>({data.term} días)</StyledB>
        </BlockBox>
      </StyledBox>
      <BlockBox
        display={['none !important', null, null, 'block!important']}
        justifyItems={'center'}
        height={'fit-content'}
        p={'24px'}
        borderRadius={'8px'}
        backgroundColor={'secondary.0'}
      >
        <Span mb={'24px'} fontSize={'14px'}>
          {CBU_CHECK_MSG}
        </Span>
        <Span>
          Alias/CBU
          <StyledB>
            {data.cbu}
            {data.alias}
          </StyledB>
        </Span>
      </BlockBox>
    </HStack>
  );
};

const BlockBox = styled(Box)({
  display: 'block',
  whiteSpace: 'normal',
});

const StyledB = styled.b({
  marginLeft: '4px',
  marginRight: '4px',
});
